import {BaseContainerModel} from "../../../base-container.model";
import {bl_alg_cc_template_message_endpoint_link_RowClass} from "../../../../dbschema";

export class TemplateMessageEndpointContainerModel extends BaseContainerModel {
  bl_alg_cc_template_message_endpoint_link: bl_alg_cc_template_message_endpoint_link_RowClass = new bl_alg_cc_template_message_endpoint_link_RowClass();
}
